import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index'

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    redirect: '/home',
    component: Index,
    children: [
      {
        path: '/home',
        name: 'Home',
        meta: {
          title: '首页'
        },
        component: () => import('@/views/home/index.vue')
      },
      {
        path: '/theme-active',
        name: 'ThemeActive',
        meta: {
          title: '主题活动'
        },
        component: () => import('@/views/themeActive/index.vue')
      },
      {
        path: '/activity-detail',
        name: 'ActivityDetail',
        meta: {
          title: '活动详情'
        },
        component: () => import('@/views/themeActiveDetail/index.vue')
      },
      {
        path: '/custom-pictures',
        name: 'CustomPictures',
        meta: {
          title: '定制图库'
        },
        component: () => import('@/views/customPictures/index.vue')
      },
      {
        path: '/sign-photographer',
        name: 'SignPhotographer',
        meta: {
          title: '签约摄影师'
        },
        component: () => import('@/views/sign-photographer/index.vue')
      },
      {
        path: '/person',
        name: 'Person',
        redirect: '/person/personal-center/info',
        component: () => import('@/views/person/index.vue'),
        children: [
          {
            path: 'personal-center',
            redirect: '/person/personal-center/info',
            name: 'PersonalCenter',
            component: () => import('@/views/person/personal-center/index.vue'),
            meta: {
              title: '个人中心'
            },
            children: [
              {
                path: 'info',
                meta: {
                  title: '个人信息'
                },
                component: () => import('@/views/person/personal-center/info.vue')
              },
              {
                path: 'security',
                meta: {
                  title: '账户安全'
                },
                component: () => import('@/views/person/personal-center/security.vue')
              },
              {
                path: 'realnameauth',
                meta: {
                  title: '实名认证'
                },
                component: () => import('@/views/person/personal-center/realnameauth.vue')
              }
            ]
          },
          {
            path: 'collection',
            name: 'Collection',
            meta: {
              title: '我的收藏'
            },
            component: () => import('@/views/person/collection/index.vue')
          },
          {
            path: 'mine-works',
            name: 'MineWorks',
            meta: {
              title: '我的作品'
            },
            component: () => import('@/views/person/mine-works/index.vue'),
            redirect: '/person/mine-works/works-manage',
            children: [
              {
                path: 'works-manage',
                mata: {
                  title: '作品管理'
                },
                component: () => import('@/views/person/mine-works/works-manage/index.vue')
              },
              {
                path: 'sell-image',
                mata: {
                  title: '出售图片'
                },
                component: () => import('@/views/person/mine-works/sell-image/index.vue')
              },
              {
                path: 'sell-order',
                mata: {
                  title: '出售订单'
                },
                component: () => import('@/views/person/mine-works/sell-order/index.vue')
              },
              {
                path: 'copyrightmanager',
                meta: {
                  title: '版权管理'
                },
                component: () => import('@/views/person/mine-works/copyright/index.vue')
              },
              {
                path: 'authomanager',
                meta: {
                  title: '著作人管理'
                },
                component: () => import('@/views/person/mine-works/authomanager/index.vue')
              }
            ]
          },
          {
            path: 'shopping-cart',
            name: 'ShoppingCart',
            meta: {
              title: '购物车'
            },
            component: () => import('@/views/person/shopping-cart/index.vue')
          },
          {
            path: 'order-manage',
            name: 'OrderManage',
            meta: {
              title: '订单管理'
            },
            component: () => import('@/views/person/order-manage/index.vue')
          },
          {
            path: 'settlement',
            name: 'Settlement',
            meta: {
              title: '结算中心'
            },
            component: () => import('@/views/person/settlement/index.vue'),
            redirect: '/person/settlement/account',
            children: [
              {
                path: 'account',
                mata: {
                  title: '结算账号'
                },
                component: () => import('@/views/person/settlement/account/index.vue')
              },
              {
                path: 'bill',
                mata: {
                  title: '结算账单'
                },
                component: () => import('@/views/person/settlement/bill/index.vue')
              }
            ]
          },
          {
            path: 'photographer-auth',
            name: 'PhotographerAuth',
            meta: {
              title: '摄影师认证'
            },
            component: () => import('@/views/person/photographer-auth/index.vue')
          }
        ]
      },
      {
        path: '/image-search',
        name: 'ImageSearch',
        meta: {
          title: '图片搜索'
        },
        component: () => import('@/views/ImageSearch/index.vue')
      },
      {
        path: '/image-detail',
        name: 'ImageDetail',
        meta: {
          title: '图片详情'
        },
        component: () => import('@/views/imageDetail/index.vue')
      },
      {
        path: '/pictorial-search',
        name: 'PictorialSearch',
        meta: {
          title: '书刊搜索'
        },
        component: () => import('@/views/pictorialSearch/index.vue')
      },
      {
        path: '/pictorial-detail',
        name: 'PictorialDetail',
        meta: {
          title: '书刊详情'
        },
        component: () => import('@/views/pictorialDetail/index.vue')
      },
      {
        path: '/shop-page',
        name: 'ShopPage',
        meta: {
          title: '店铺/摄影师主页'
        },
        component: () => import('@/views/shopPage/index.vue')
      },
      {
        path: '/copyright-service',
        name: 'CopyrightService',
        meta: {
          title: '版权服务'
        },
        component: () => import('@/views/copyrightService/index.vue')
      },

      {
        path: '/info-introduce',
        name: 'InfoIntroduce',
        meta: {
          title: '宣传介绍'
        },
        component: () => import('@/views/infointroduce/index.vue')
      },

      {
        path: '/copyright-register',
        name: 'CopyrightRigister',
        meta: {
          title: '版权登记'
        },
        component: () => import('@/views/copyrightRigister/index.vue')
      },
      {
        path: '/pay',
        name: 'Pay',
        meta: {
          title: '支付页面'
        },
        component: () => import('@/views/pay/index.vue')
      },
      {
        path: '/wx-login',
        name: 'WxLogin',
        meta: {
          title: '微信登录用于重定向的页面'
        },
        component: () => import('@/views/loginRedirect/wx.vue')
      },
      {
        path: '/wx-bounde',
        name: 'WxBound',
        meta: {
          title: '微信绑定用于重定向的页面'
        },
        component: () => import('@/views/loginRedirect/bounde.vue')
      },
      {
        path: '/wx-code',
        name: 'WxCode',
        meta: {
          title: '用于其他系统获取微信的登录code'
        },
        component: () => import('@/views/loginRedirect/code.vue')
      },
      {
        path: '/similar-list',
        name: 'SimilarList',
        meta: {
          title: '相似图片'
        },
        component: () => import('@/views/similarList/index')
      },
      {
        path: '/search-by-image',
        name: 'SearchByImage',
        meta: {
          title: '以图搜图'
        },
        component: () => import('@/views/searchByImage/index')
      },
      {
        path: '/aboutus',
        name: 'Aboutus',
        meta: {
          title: '关于我们'
        },
        component: () => import('@/views/Aboutus/indexnew.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
